import { createReducer, on } from '@ngrx/store';
import { setTotalPremiumDifferenceAction } from './totalPremiumDifference.actions';

export const initialState = 0;

export const totalPremiumDifferenceReducer = createReducer(
  initialState,
  on(setTotalPremiumDifferenceAction, (state, { totalPremiumDifference }) => totalPremiumDifference)
);
